export const ServiceTypeEnum = {
  assignment: "assignment",
  analysis: "analysis",
  bundle: "servicetype_bundle",
};
